import { Modal } from 'react-bootstrap'
import { useState, useEffect } from 'react'

// import {ToastMessageContainer} from '../../../../../_ePulse/layout/components/ToastMessageContainer'
import { toast } from 'react-toastify'
import { ToastMessageContainer } from '../../../../../../_ePulse/layout/components/ToastMessageContainer'

export const CreateTestGroup = (props: any) => {
  const [groupName, setGroupName] = useState<any>(null)
  const [productName, setProductName] = useState<any>(null)

  useEffect(() => {

    if(props.field) {
     console.log("props.field", props.field.productValue)
      setProductName(props.field.productValue || '')
    }
  }, [props])

  const handleCreateTestGroup = () => {
    if (!groupName || !productName) {
      toast.error('Please fill all the fields')
      return
    }
    
    props.handleAddNewTestGroup({ "productGroup": productName, "testGroupName": groupName });
    props.onClose()
  }




  return (
    <Modal
      show={true}
      dialogClassName='ePulse-modal ePulse-modal-50w'
      onHide={() => props.onClose()}
      backdrop='static'
    >
      <Modal.Header className='border-0' closeButton>
        <div>
          <ToastMessageContainer />
        </div>
        <span className='fs-3 fw-bold'>Text Group Entry Form </span>
      </Modal.Header>
      <Modal.Body className='container' />
      <div className='ePulse-modal-content'>


        <div className='modal-body'>
          <div className='form-group'>
            <label>Group Name</label>
            <input

              type='text'
              className='form-control'
              placeholder='Enter Group Name'
              value={groupName}
              onChange={(e) => setGroupName(e.target.value)}
            />
          </div>
          <div className='form-group'>
            <label>Product Name</label>
            <input
              type='text'
              className='form-control'
              value={productName}
              onChange={(e) => setProductName(e.target.value)}
            />
          </div>
        </div>

        <div className='btn-row'>
            <button
            className='ePulse-btn-primary'
            type='button'
            onClick={() => {
handleCreateTestGroup()
            }}
            >
             Create
            </button>
        </div>
      </div>
    </Modal>
  )
}
